import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { PlotFormProps } from '../../../../forms/InitiWidgetFormHandler';
import {
  getTextValue,
  isValid,
  setTextValue,
} from '../../../../state/dashboard-element-operations';
import {
  PlotConfigFormShell,
  PlotConfigSection,
  PlotConfigSubmitButton,
} from '../shared/plotConfigFormLayout';

function TextForm({ config, onSubmit, onChange }: PlotFormProps) {
  const [isSending, setIsSending] = useState(false);
  const [validation, setValidation] = useState(isValid(config));

  const handleDefaultValueChange = (value: string) => {
    const newConfig = setTextValue(value, config);
    setValidation(isValid(newConfig));
    onChange(newConfig);
  };

  const handleSubmit: React.FormEventHandler = (e) => {
    e.preventDefault();
    if (validation[0]) {
      setIsSending(true);
      onSubmit(config).finally(() => setIsSending(false));
    }
  };

  return (
    <PlotConfigFormShell onSubmit={handleSubmit}>
      <PlotConfigSection title="Texte à afficher">
        <TextField
          size="small"
          fullWidth
          multiline
          minRows={3}
          label="Texte à afficher"
          defaultValue={getTextValue(config) ?? ''}
          onChange={(event) => handleDefaultValueChange(event.target.value)}
        />
      </PlotConfigSection>

      <PlotConfigSubmitButton isSending={isSending} />
    </PlotConfigFormShell>
  );
}

export default TextForm;
